import React from "react";
import card_items from "./cards";
import resultCards from "./resultCards";

import chips from "../../../chips";
import cardFallSound from "../../../../../../assets/sounds/slide.mp3";
import betoncard from "../../../../../../assets/sounds/betoncard.mp3";
import BottomPanel from './bottomPanel';

import { connect } from "react-redux";
import { Howl } from "howler";
import gsap from "gsap";
import deck from '../../../../../../assets/games/andarBaharTimer/cardDeck.png'
class ChipsDealerPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlayingChip: false,
      chipSelect: 1,
      index: -1,
      currentCard: 0,
      DlrCards: [],
      PlrCards: [],
      getRes: "",
      betResults: [],
      setTimeDealer: 250,
      setTimePlayer: 250,
      winnerObj: [],
      betObj: [],
      cardsObj: [],
    };
    this.audio = null;
    this.audioD = null;
    this.cardsInt = "";
    this.a = 0;
    this.startInt = null;
    this.updateHistoryData = [];
    this.winnerNameObj = [];
    this.winnerObj = [];
    this.betObj = [];
    this.cardsObj = [];

    this.chipVal = [
      { label: "1k", val: 1000 },
      { label: "5k", val: 5000 },
      { label: "10k", val: 10000 },
      { label: "10k", val: 10000 },
      { label: "50k", val: 50000 },
      { label: "100k", val: 100000 },
      { label: "5M", val: 5000000 },
      { label: "1B", val: 100000000 },
      { label: "", val: 0 }
    ];
  }
  componentDidMount() {
    this.betSoundHowler = this.initializeChipSound()
    if (this.props.fc_chipValues) {
      let newChips = this.props.fc_chipValues.split(",");
      // console.log(newChips);
      // console.log(newChips.length)
      let lblTxt = "";
      for (let i = 0; i < newChips.length; i++) {
        if (Number(newChips[i]) >= 1000 && Number(newChips[i]) <= 999999) {
          lblTxt = "K"
        } else if (Number(newChips[i]) >= 1000000 && Number(newChips[i]) <= 999999999) {
          lblTxt = "M"
        } else if (Number(newChips[i]) > 999999999) {
          lblTxt = "B"
        }
        this.chipVal[i].val = newChips[i]
        // console.log(this.chipVal[i].val, lblTxt);
        this.checkChipValue(Number(this.chipVal[i].val), lblTxt, i);
      }
    }
    const { childRef } = this.props;
    childRef(this);
  }

  checkChipValue(chipValue, chpTxt, i) {
    if (chipValue >= 1000) {
      chipValue = chipValue / 1000;
      this.checkChipValue(chipValue, chpTxt, i)
    } else {
      // console.log(chpTxt);
      this.showResultChipValue(chipValue, chpTxt, i);
      return chipValue
    }
  }

  showResultChipValue(chVal, chipTxt, index) {
    // console.log(chVal);
    console.log(chVal + "" + chipTxt)
    this.chipVal[index].label = chVal + "" + chipTxt;
    // console.log(this.chipVal)
  }

  componentWillUnmount() {
    this.audio = null;
    this.audioD = null;
    this.setState({
      DlrCards: [],
      PlrCards: [],
    })
  }

  // dealerCards = () => {
  //   this.setState({
  //     DlrCards: [],
  //     PlrCards: [],
  //   })

  //   if (this.props.delearFirst) {
  //     this.state.setTimeDealer = 0
  //     this.state.setTimePlayer = 250
  //   } else {
  //     this.state.setTimePlayer = 0
  //     this.state.setTimeDealer = 250
  //   }
  //   var dealerBox = document.getElementById("dealerBox");
  //   var playerBox = document.getElementById("playerBox");

  //   this.setState({
  //     DlrCards: this.props.funCardResult.dealerCards,
  //     PlrCards: this.props.funCardResult.playerCards,
  //   });
  //   console.log(this.state.DlrCards);
  //   console.log(this.state.PlrCards);

  //   /****************DEALER CARDS SHOWING AFTER DEAL START ******************/
  //   console.log(this.state.setTimeDealer);

  //   setTimeout(() => {

  //     var dlrArray = [];
  //     for (var v = 0; v < this.state.DlrCards.length; v++) {
  //       for (var b = 0; b < resultCards.length; b++) {
  //         if (resultCards[b].rsc_val === this.state.DlrCards[v]) {
  //           dlrArray.push(resultCards[b].src);
  //         }
  //       }
  //     }

  //     var plrArray = [];
  //     for (var pl = 0; pl < this.state.PlrCards.length; pl++) {
  //       for (var rs = 0; rs < resultCards.length; rs++) {
  //         if (resultCards[rs].rsc_val === this.state.PlrCards[pl]) {
  //           plrArray.push(resultCards[rs].src);
  //         }
  //       }
  //     }

  //     let totalCardsTime = dlrArray.length + plrArray.length;

  //     let pCount = 0;
  //     let dCount = 0;
  //     const myLoop = (dPlus) => {

  //       console.log("Dealer Array: " + dlrArray.length);
  //       // if (this.props.delearFirst) {
  //       //   if (dPlus % 2 == 0) {
  //       //     if (this.audioD) {
  //       //       this.audioD.play()
  //       //     }
  //       //     dealerBox.innerHTML += `<img class="dCard_${dCount + 1}" alt=${dCount} src=${dlrArray[dCount]} />`;
  //       //     dCount++;
  //       //   } else {
  //       //     if (this.audio) {
  //       //       this.audio.play()
  //       //     }
  //       //     playerBox.innerHTML += `<img src=${plrArray[pCount]} />`;
  //       //     pCount++;
  //       //   }
  //       // } else {
  //       //   if (dPlus % 2 != 0) {
  //       //     if (this.audioD) {
  //       //       this.audioD.play()
  //       //     }
  //       //     dealerBox.innerHTML += `<img class="dCard_${dCount + 1}" alt=${dCount} src=${dlrArray[dCount]} />`;
  //       //     dCount++;
  //       //   } else {
  //       //     if (this.audio) {
  //       //       this.audio.play()
  //       //     }
  //       //     playerBox.innerHTML += `<img src=${plrArray[pCount]} />`;
  //       //     pCount++;
  //       //   }
  //       // }
  //       const portrait = window.innerHeight > window.innerWidth;
  //       if (this.props.delearFirst) {
  //         if (dPlus % 2 == 0) {
  //           if (dCount < dlrArray.length) {
  //             const img = document.createElement("img");
  //             img.className = `dCard_${dCount + 1}`;
  //             img.alt = dCount;
  //             img.src = dlrArray[dCount];
  //             img.style.opacity = 0
  //             dealerBox.appendChild(img);
  //             img.onload = () => {
  //               // GSAP animation for dealer card
  //               if (this.audioD) {
  //                 this.audioD.play()
  //               }
  //               img.style.opacity = 1

  //               const centerX = 625 - (img.width - 80) * dCount
  //               gsap.from(img, {
  //                 duration: 0.5,
  //                 height: 20,
  //                 x: portrait ? centerX : 3400,
  //                 y: portrait ? -1500 : -1200,
  //                 z: 1000,
  //                 ease: "power3.inOut"
  //               });
  //             }

  //             dCount++;
  //           }
  //         } else {
  //           if (pCount < plrArray.length) {
  //             const img = document.createElement("img");
  //             img.className = `dCard_${pCount + 1}`;
  //             img.alt = pCount;
  //             img.src = plrArray[pCount];
  //             img.style.opacity = 0
  //             playerBox.appendChild(img);
  //             img.onload = () => {
  //               img.style.opacity = 1
  //               if (this.audio) {
  //                 this.audio.play()
  //               }
  //               // GSAP animation for dealer card
  //               console.log("2", pCount, 1250, img.width)
  //               const centerX = 625 - (img.width - 80) * pCount

  //               // GSAP animation for player card
  //               gsap.from(img, {
  //                 duration: 0.5,
  //                 height: 20,
  //                 x: portrait ? centerX : 2800,
  //                 y: portrait ? -1700 : -1200,
  //                 z: 1000,
  //                 ease: "power3.inOut"
  //               });
  //             }

  //             pCount++;
  //           }
  //         }
  //       } else {
  //         if (dPlus % 2 != 0) {
  //           if (dCount < dlrArray.length) {
  //             const img = document.createElement("img");
  //             img.className = `dCard_${dCount + 1}`;
  //             img.alt = dCount;
  //             img.src = dlrArray[dCount];
  //             img.style.opacity = 0
  //             dealerBox.appendChild(img);
  //             img.onload = () => {
  //               // GSAP animation for dealer card
  //               img.style.opacity = 1
  //               if (this.audioD) {
  //                 this.audioD.play()
  //               }
  //               console.log("3", dCount, 1250, img.width)
  //               const centerX = 625 - (img.width - 80) * dCount
  //               // GSAP animation for dealer card
  //               gsap.from(img, {
  //                 duration: 0.5,
  //                 height: 20,
  //                 x: portrait ? centerX : 3400,
  //                 y: portrait ? -1500 : -1200,
  //                 z: 1000,
  //                 ease: "power3.inOut"
  //               });
  //             }

  //             dCount++;
  //           }
  //         } else {
  //           if (pCount < plrArray.length) {
  //             const img = document.createElement("img");
  //             img.className = `dCard_${pCount + 1}`;
  //             img.alt = pCount;
  //             img.src = plrArray[pCount];
  //             img.style.opacity = 0
  //             playerBox.appendChild(img);

  //             // GSAP animation for player card
  //             img.onload = () => {
  //               console.log("4", pCount, 1250, img.width)
  //               img.style.opacity = 1;
  //               if (this.audio) {
  //                 this.audio.play()
  //               }
  //               // GSAP animation for dealer card
  //               const centerX = 625 - (img.width - 80) * pCount
  //               gsap.from(img, {
  //                 duration: 0.5,
  //                 height: 20,
  //                 x: portrait ? centerX : 2800,
  //                 y: portrait ? -1700 : -1200,
  //                 z: 1000,
  //                 ease: "power3.inOut"
  //               });
  //             }
  //             pCount++;
  //           }
  //         }
  //       }



  //     }
  //     var i = 0;
  //     const countDlr = () => {
  //       var dPlus = i++;
  //       console.log("dPlus:  " + dPlus);
  //       if (dPlus < totalCardsTime) {
  //         myLoop(dPlus);
  //       }
  //     }
  //     const myDlr = setInterval(function () {
  //       countDlr()
  //     }, 600);

  //     setTimeout(() => {
  //       clearInterval(myDlr);


  //     }, totalCardsTime * 650);

  //   }, this.state.setTimeDealer)

  //   /****************DEALER CARDS SHOWING AFTER DEAL END ******************/
  // };


  //   dealerCards = () => {
  //   const { funCardResult, delearFirst } = this.props;

  //   // Reset dealer and player areas
  //   const dealerBox = document.getElementById("dealerBox");
  //   const playerBox = document.getElementById("playerBox");
  //   dealerBox.innerHTML = "";
  //   playerBox.innerHTML = "";

  //   // Prepare card arrays
  //   const DlrCards = funCardResult.dealerCards;
  //   const PlrCards = funCardResult.playerCards;

  //   const dlrArray = DlrCards.map(card => {
  //     const found = resultCards.find(r => r.rsc_val === card);
  //     return found ? found.src : null;
  //   }).filter(Boolean);

  //   const plrArray = PlrCards.map(card => {
  //     const found = resultCards.find(r => r.rsc_val === card);
  //     return found ? found.src : null;
  //   }).filter(Boolean);

  //   const portrait = window.innerHeight > window.innerWidth;
  //   const totalCards = Math.max(dlrArray.length, plrArray.length) * 2;
  //   let dCount = 0;
  //   let pCount = 0;

  //   const createAndAnimateCard = (src, count, isDealer, container, audio) => {
  //     const img = document.createElement("img");
  //     img.className = `dCard_${count + 1}`;
  //     img.alt = count;
  //     img.src = src;
  //     img.style.opacity = 0;
  //     container.appendChild(img);

  //     img.onload = () => {
  //       img.style.opacity = 1;
  //       if (audio) audio.play();

  //       const centerX = 625 - (img.width - 80) * count;
  //       const animX = portrait ? centerX : isDealer ? 3400 : 2800;
  //       const animY = portrait ? (isDealer ? -1500 : -1700) : -1200;

  //       gsap.from(img, {
  //         duration: 0.5,
  //         height: 20,
  //         x: animX,
  //         y: animY,
  //         z: 1000,
  //         ease: "power3.inOut"
  //       });
  //     };
  //   };

  //   const dealSequentially = (index = 0) => {
  //     if (index >= dlrArray.length + plrArray.length) return;

  //     const isDealerTurn = delearFirst ? index % 2 === 0 : index % 2 !== 0;

  //     if (isDealerTurn && dCount < dlrArray.length) {
  //       createAndAnimateCard(dlrArray[dCount], dCount, true, dealerBox, this.audioD);
  //       dCount++;
  //     } else if (!isDealerTurn && pCount < plrArray.length) {
  //       createAndAnimateCard(plrArray[pCount], pCount, false, playerBox, this.audio);
  //       pCount++;
  //     }

  //     // Schedule next card after delay
  //     setTimeout(() => {
  //       dealSequentially(index + 1);
  //     }, 650);
  //   };

  //   // Start the card dealing after delay
  //   const delayBeforeStart = delearFirst ? 0 : 250;
  //   setTimeout(() => {
  //     dealSequentially();
  //   }, delayBeforeStart);
  // };



  // dealerCards = () => {
  //   const { funCardResult, delearFirst } = this.props;

  //   // Clear existing cards
  //   const dealerBox = document.getElementById("dealerBox");
  //   const playerBox = document.getElementById("playerBox");
  //   dealerBox.innerHTML = "";
  //   playerBox.innerHTML = "";
  //   dealerBox.style.marginLeft = "80px";
  //   playerBox.style.marginLeft = "80px";

  //   // Prepare card arrays
  //   const DlrCards = funCardResult.dealerCards;
  //   const PlrCards = funCardResult.playerCards;

  //   const dlrArray = DlrCards.map(card => {
  //     const found = resultCards.find(r => r.rsc_val === card);
  //     return found ? found.src : null;
  //   }).filter(Boolean);

  //   const plrArray = PlrCards.map(card => {
  //     const found = resultCards.find(r => r.rsc_val === card);
  //     return found ? found.src : null;
  //   }).filter(Boolean);

  //   let dCount = 0;
  //   let pCount = 0;

  //   // Fixed top-right screen coordinates


  //   const createAndAnimateCard = (src, count, isDealer, container, audio, x, y, totalcardlength, onComplete) => {
  //     const img = document.createElement("img");
  //     img.className = `dCard_${count + 1}`;
  //     img.alt = count;
  //     img.src = src;
  //     img.style.opacity = 0;
  //     img.style.zIndex = count + 1;
  //     img.style.marginLeft = "-80px";
  //     container.appendChild(img);

  //     img.onload = () => {
  //       img.style.opacity = 1;
  //       if (audio) audio.play?.();

  //       const imgRect = img.getBoundingClientRect();



  //       // console.log(x - count * 80, x, count, count * 80, isDealer ? "dealer" : "player", ((imgRect.width) * count + (imgRect.x) * count), imgRect.width * totalcardlength, (imgRect.x))

  //       const spreadOffset = (count * imgRect.width) * 0.8; // e.g., each card is offset by 30px
  //       const startX = x - spreadOffset;


  //       gsap.from(img, {
  //         duration: 0.4,
  //         // x: x - count*80,
  //         x: (startX - imgRect.x),
  //         // x: x -imgRect?.x-(imgRect.width/2),
  //         // x: x - imgRect.left / 2,
  //         y: y,
  //         height: 0,
  //         width: 0,
  //         z: 1000,
  //         ease: "power3.inOut",
  //         onComplete: onComplete
  //       });
  //     };
  //   };

  //   const dealSequentially = (index = 0) => {
  //     if (index >= dlrArray.length + plrArray.length) {
  //       setTimeout(() => {

  //         this.props.winPop()
  //       }, 500)
  //       return;
  //     }

  //     const isDealerTurn = delearFirst ? index % 2 === 0 : index % 2 !== 0;

  //     const onNext = () => {
  //       // Optional: Add delay between cards
  //       setTimeout(() => {
  //         dealSequentially(index + 1);
  //       }, 80); // 100ms pause between cards
  //     };
  //     const portrait = window.innerHeight > window.innerWidth;
  //     const x = portrait ? 470 : 2600
  //     const y = portrait ? -1120 : -650
  //     if (isDealerTurn && dCount < dlrArray.length) {
  //       createAndAnimateCard(dlrArray[dCount], dCount, true, dealerBox, this.audioD, x, y, dlrArray.length, onNext);
  //       dCount++;
  //     } else if (!isDealerTurn && pCount < plrArray.length) {
  //       createAndAnimateCard(plrArray[pCount], pCount, false, playerBox, this.audio, x, y - 230, plrArray.length, onNext);
  //       pCount++;
  //     } else {
  //       onNext(); // No card to deal, move to next
  //     }
  //   };

  //   // Start dealing after short delay if needed
  //   const delayBeforeStart = delearFirst ? 0 : 250;
  //   setTimeout(() => {
  //     dealSequentially();
  //   }, delayBeforeStart);
  // };


  dealerCards = () => {
    const { funCardResult, delearFirst } = this.props;

    // Clear existing cards
    const dealerBox = document.getElementById("dealerBox");
    const playerBox = document.getElementById("playerBox");
    dealerBox.innerHTML = "";
    playerBox.innerHTML = "";
    dealerBox.style.marginLeft = "80px";
    playerBox.style.marginLeft = "80px";

    // Prepare card arrays
    const DlrCards = funCardResult.dealerCards;
    const PlrCards = funCardResult.playerCards;

    console.log(DlrCards, PlrCards)

    const dlrArray = DlrCards.map(card => {
      const found = resultCards.find(r => r.rsc_val === card);
      return found ? found.src : null;
    }).filter(Boolean);

    const plrArray = PlrCards.map(card => {
      const found = resultCards.find(r => r.rsc_val === card);
      return found ? found.src : null;
    }).filter(Boolean);


    let dCount = 0;
    let pCount = 0;

    // Fixed top-right screen coordinates
    const suitSymbol = (suit) => {
      return {
        "D": `<div class="diamondCard"></div>`,
        "S": `<div class="spadeCard"><div class="spadeTale"></div></div>`,
        "C": `<div class="clubCard"><div class="clubTale"></div></div>`,
        "H": `<div class="heartCard"></div>`
      }[suit] || '';
    };
    const createCardDiv = (value, count) => {
      const suit = value.slice(-1);
      const rank = value.slice(0, -1) === 'T' ? '10' : value.slice(0, -1);
      const color = (suit === 'H' || suit === 'D') ? 'red' : 'black';
      const symbol = suitSymbol(suit);

      const card = document.createElement('div');
      card.className = `dCard_${count + 1} miniab`;
      card.style.color = color;
      card.style.background = "#fff";

      card.alt = count;

      card.style.opacity = 0;
      card.style.zIndex = count + 1;
      card.style.top = "0px"
      card.style.left = `${60 * count}px`
      // card.style.marginLeft = "-80px";


      const topLeft = document.createElement('div');
      topLeft.className = "miniabtopleft";
      topLeft.textContent = rank;

      const center = document.createElement('div');
      center.className = "miniabcenterdiv";
      center.innerHTML = symbol;

      const bottomRight = document.createElement('div');
      bottomRight.className = "miniabbottomright";
      bottomRight.innerHTML = symbol;

      card.appendChild(topLeft);
      card.appendChild(center);
      card.appendChild(bottomRight);

      return card;
    };

    const createAndAnimateCard = (cardValue, count, isDealer, container, audio, x, y, totalcardlength, onComplete) => {
      const card = createCardDiv(cardValue, count);
      container.appendChild(card);

      // Wait for the DOM to render the card before getting its position
      requestAnimationFrame(() => {
        card.style.opacity = 1;
        if (audio) audio.play?.();

        const cardRect = card.getBoundingClientRect();

        const spreadOffset = (count * cardRect.width) * 0.8;
        const startX = x;
        // const startX = x - spreadOffset;
        card.style.transform = "scale(1)"
        gsap.from(card, {
          duration: 0.4,
          // x: (startX - cardRect.x),
          x: (startX),
          y: y,
          // opacity:0,
          // height: 92.5,
          // width: 70,
          scale: 0,
          z: 1000,
          ease: "power3.inOut",
          onComplete: onComplete
        });
      });
    };
    const dealSequentially = (index = 0) => {
      if (index >= DlrCards.length + PlrCards.length) {
        setTimeout(() => {

          this.props.winPop()
        }, 500)
        return;
      }

      const isDealerTurn = delearFirst ? index % 2 === 0 : index % 2 !== 0;

      const onNext = () => {
        // Optional: Add delay between cards
        setTimeout(() => {
          dealSequentially(index + 1);
        }, 80); // 100ms pause between cards
      };
      const portrait = window.innerHeight > window.innerWidth;
      const x = portrait ? 470 : 2600
      const y = portrait ? -1120 : -650
      if (isDealerTurn && dCount < DlrCards.length) {
        createAndAnimateCard(DlrCards[dCount], dCount, true, dealerBox, this.audioD, x, y, DlrCards.length, onNext);
        dCount++;
      } else if (!isDealerTurn && pCount < PlrCards.length) {
        createAndAnimateCard(PlrCards[pCount], pCount, false, playerBox, this.audio, x, y - 230, PlrCards.length, onNext);
        pCount++;
      } else {
        onNext(); // No card to deal, move to next
      }
    };

    // Start dealing after short delay if needed
    const delayBeforeStart = delearFirst ? 0 : 250;
    setTimeout(() => {
      dealSequentially();
    }, delayBeforeStart);
  };




  showCardHistory = (targetHistory) => {
    // console.log(targetHistory);
    if (this.props.delearFirst) {
      this.state.setTimeDealer = 0
      this.state.setTimePlayer = 10
    } else {
      this.state.setTimePlayer = 0
      this.state.setTimeDealer = 10
    }
    var dealerBox = document.getElementById("dealerBox");
    var playerBox = document.getElementById("playerBox");

    // console.log(this.props.funCardResult);

    if (targetHistory.dealerCards.length > 0) {
      this.setState({ DlrCards: targetHistory.dealerCards });
      this.state.DlrCards = targetHistory.dealerCards;
    }
    if (targetHistory.playerCards.length > 0) {
      this.setState({ PlrCards: targetHistory.playerCards });
      this.state.PlrCards = targetHistory.playerCards;
    }

    //setTimeout(()=>{
    if (this.state.DlrCards.length > 0) {
      var dlrArray = [];
      for (var v = 0; v < this.state.DlrCards.length; v++) {
        for (var b = 0; b < resultCards.length; b++) {
          if (resultCards[b].rsc_val === this.state.DlrCards[v]) {
            dlrArray.push(resultCards[b].src);
          }
        }
      }
    }

    if (this.state.PlrCards.length > 0) {
      var plrArray = [];
      for (var pl = 0; pl < this.state.PlrCards.length; pl++) {
        for (var rs = 0; rs < resultCards.length; rs++) {
          if (resultCards[rs].rsc_val === this.state.PlrCards[pl]) {
            plrArray.push(resultCards[rs].src);
          }
        }
      }
    }

    // console.log(dlrArray);
    // console.log(plrArray);

    let totalCardsTime = dlrArray.length + plrArray.length + 1;

    let pCount = 0;
    let dCount = 0;
    const myLoop = (dPlus) => {
      // console.log("Dealer Array: " + dlrArray.length);
      // if (this.props.delearFirst) {
      //   if (dPlus % 2 == 0) {
      //     if (dCount < dlrArray.length) {
      //       dealerBox.innerHTML += `<img class="dCard_${dCount + 1}" alt=${dCount} src=${dlrArray[dCount]} />`;
      //       dCount++;
      //     }
      //   } else {
      //     if (pCount < plrArray.length) {
      //       playerBox.innerHTML += `<img src=${plrArray[pCount]} />`;
      //       pCount++;
      //     }
      //   }
      // } else {
      //   if (dPlus % 2 != 0) {
      //     if (dCount < dlrArray.length) {
      //       dealerBox.innerHTML += `<img class="dCard_${dCount + 1}" alt=${dCount} src=${dlrArray[dCount]} />`;
      //       dCount++;
      //     }
      //   } else {
      //     if (pCount < plrArray.length) {
      //       playerBox.innerHTML += `<img src=${plrArray[pCount]} />`;
      //       console.log(pCount);
      //       pCount++;
      //     }
      //   }
      // }



      const portrait = window.innerHeight > window.innerWidth;
      if (this.props.delearFirst) {
        if (dPlus % 2 == 0) {
          if (dCount < dlrArray.length) {
            const img = document.createElement("img");
            img.className = `dCard_${dCount + 1}`;
            img.alt = dCount;
            img.src = dlrArray[dCount];
            dealerBox.appendChild(img);
            img.onload = () => {
              // GSAP animation for dealer card

              const centerX = 625 - (img.width - 80) * dCount
              gsap.from(img, {
                duration: 0.5,
                height: 20,
                x: portrait ? centerX : 3400,
                y: portrait ? -1500 : -1200,
                z: 1000,
                ease: "power3.inOut"
              });
            }

            dCount++;
          }
        } else {
          if (pCount < plrArray.length) {
            const img = document.createElement("img");
            img.src = plrArray[pCount];
            playerBox.appendChild(img);
            img.onload = () => {
              // GSAP animation for dealer card
              // console.log("2", pCount, 1250, img.width)
              const centerX = 625 - (img.width - 80) * pCount
              // GSAP animation for player card
              gsap.from(img, {
                duration: 0.5,
                height: 20,
                x: portrait ? centerX : 2800,
                y: portrait ? -1700 : -1200,
                z: 1000,
                ease: "power3.inOut"
              });
            }

            pCount++;
          }
        }
      } else {
        if (dPlus % 2 != 0) {
          if (dCount < dlrArray.length) {
            const img = document.createElement("img");
            img.className = `dCard_${dCount + 1}`;
            img.alt = dCount;
            img.src = dlrArray[dCount];
            dealerBox.appendChild(img);
            img.onload = () => {
              // GSAP animation for dealer card
              // console.log("3", dCount, 1250, img.width)
              const centerX = 625 - (img.width - 80) * dCount
              // GSAP animation for dealer card
              gsap.from(img, {
                duration: 0.5,
                height: 20,
                x: portrait ? centerX : 3400,
                y: portrait ? -1500 : -1200,
                z: 1000,
                ease: "power3.inOut"
              });
            }

            dCount++;
          }
        } else {
          if (pCount < plrArray.length) {
            const img = document.createElement("img");
            img.src = plrArray[pCount];
            playerBox.appendChild(img);

            // GSAP animation for player card
            img.onload = () => {
              // console.log("4", pCount, 1250, img.width)
              // GSAP animation for dealer card
              const centerX = 625 - (img.width - 80) * pCount
              gsap.from(img, {
                duration: 0.5,
                height: 20,
                x: portrait ? centerX : 2800,
                y: portrait ? -1700 : -1200,
                z: 1000,
                ease: "power3.inOut"
              });
            }
            pCount++;
          }
        }
      }




    }
    var i = 0;
    const countDlr = () => {
      var dPlus = i++;
      myLoop(dPlus);
    }
    const myDlr = setInterval(function () {
      countDlr()
    }, 10);

    setTimeout(() => {
      clearInterval(myDlr);
    }, totalCardsTime * 100);

    //}, this.state.setTimeDealer)

    /****************DEALER CARDS SHOWING AFTER DEAL END ******************/
  };


  cleareCards() {
    document.getElementById("dealerBox").innerHTML = ``;
    document.getElementById("playerBox").innerHTML = ``;
  }
  playchipssounds = (chipSound) => {
    const { isPlayingChip } = this.state;
    let currentSound = chipSound;

    if (isPlayingChip && currentSound) {
      chipSound.stop();
    }
    if (!chipSound) {
      currentSound = this.initializeChipSound();
    }

    if (currentSound) {
      currentSound.play();
      this.setState({
        isPlayingChip: true
      })

    }

  };

  initializeChipSound = () => {
    let chipSound = new Howl({
      src: [betoncard],
      html5: true, // Enable HTML5 Audio for mobile compatibility
    });
    this.setState({
      chipSound,
      isPlayingChip: false
    })
    return chipSound
  }

  mouseDownSelectCard(data) {
    this.audio = new Audio(cardFallSound);
    this.audioD = new Audio(cardFallSound);
    clearInterval(this.startInt);
    document.getElementById("card_" + data).style.transform = "scale(0.9)";
    this.props.selectedCard(data)
    // this.betoncard = new Audio(betoncard)
    // this.betoncard.play();
    this.playchipssounds(this.betSoundHowler)
    this.startInt = setInterval(() => {
      // this.betoncard2 = new Audio(betoncard)
      // this.betoncard2.play();
      this.playchipssounds(this.betSoundHowler)
      this.props.selectedCard(data)
    }, 120);
  }
  mouseUpStopCards(cardNum) {
    if (document.getElementById("card_" + cardNum)) {
      setTimeout(() => {
        document.getElementById("card_" + cardNum).style.transform = "scale(1)";
      }, 100);
    }
    clearInterval(this.startInt);
  }

  updateHistory(historyData) {
    this.updateHistoryData = historyData;
    // console.log(historyData)
    // console.log("###############################################################");
    // console.log(this.updateHistoryData[0]);
    // console.log(this.updateHistoryData[1]);
    // console.log(this.updateHistoryData[2]);
    if (historyData.length == 3) {

      historyData[2].map(result => {
        if (result === "Player") {


          this.setState(prevState => ({
            cardsObj: [...prevState.cardsObj, this.props.language.Player]
          }))

        } else {

          this.setState(prevState => ({
            cardsObj: [...prevState.cardsObj, this.props.language.Dealer]
          }))

        }
      })
    }


    this.winnerObj = this.updateHistoryData[0];
    this.betObj = this.updateHistoryData[1];
    this.cardsObj = this.updateHistoryData[2];


    // console.log(this.cardsObj);

    console.log("###############################################################");


  }

  getLanguagePlayerDeal = () => {
    let plyDel = []
    this.cardsObj.map((data, i) => {

      if (data === "Player") {
        // console.log(data)
        plyDel.push(this.props.language.Player)

      } else if (data === "Dealer") {
        plyDel.push(this.props.language.Dealer)

      }
    })

    return plyDel

  }

  render() {
    let player = this.getLanguagePlayerDeal()
    return (
      <React.Fragment>
        <div className="fd">
          {/* <div id="deck" className="deck">
            <img src={deck} />
          </div> */}
          <div></div>
          {/************************** PLAY CARDS START  ******************/}
          <div className="fd cards p_lr_20 m_tb_35">
            {card_items.map((data) => (
              <div
                className="cardDiv"
                id={"card_" + data.c_val}
                key={data.c_val}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.currentTarget.style.transform = "scale(0.9)";
                  this.mouseDownSelectCard(data.c_val)
                  // this.props.selectedCard(data.c_val);
                }}
                onMouseUp={(e) => { this.mouseUpStopCards(data.c_val) }}
                onMouseOut={(e) => { this.mouseUpStopCards(data.c_val) }}
              >
                <img src={data.src} alt={data.c_val} />
                <div className="gldDiv" id={"fID_" + data.c_val}>

                </div>
              </div>
            ))}
          </div>
          {/************************** PLAY CARDS END  ******************/}
          <div className="fd  p_lr_10">
            <div className="row">
              {/************************** DEALER & PLAYER TABLE START  ******************/}
              <div className="funCardTable">
                <div className="AddCards">
                  <div className="cardBox">
                    <div className="dealerBox" id="dealerBox"></div>
                    <span className="boxName"> {this.props.language.Dealer} </span>
                  </div>
                  <div className="cardBox">
                    <div className="playerBox " id="playerBox"></div>
                    <span className="boxName"> {this.props.language.Player} </span>
                  </div>

                  {/************************** CHIPS RIGHT END  ******************/}
                  <div className="funCardChips chipsRight">
                    {chips.map((value, index) =>

                      <div className="chipCard" key={index} onClick={(e) => {
                        e.preventDefault();
                        this.props.getChipVal(`${this.chipVal[index].val}`);
                        this.setState({ chipSelect: value.val });
                      }}>
                        <img
                          className={this.state.chipSelect === value.val ? "active" : "inactive"}
                          src={value.src}

                          alt={value.src}
                        />
                        <div className="fc_overlay_text"> {this.chipVal[index].label}</div>
                      </div>


                      //     <div key={imgs.src} className="chipSorat">
                      //     <p className="chipImg" onClick={(e)=> {e.preventDefault(); this.props.betAmount(`${this.chipVal[i].val}`, `${this.chipVal[i].label}`);this.setState({chipSelect : imgs.val})}} >
                      //         <img src={imgs.src} alt={imgs.src} className={this.state.chipSelect === imgs.val ? 'active chp_img Select' : 'chp_img UnSelect'}  />
                      //         {/* <span className={`fst_chip${i}`}>{this.chipVal[i].label}</span> */}
                      //         <div class="fst_overlay_text"> {this.chipVal[i].label}
                      //         </div>
                      //     </p>
                      // </div>

                    )}
                  </div>
                  {/************************** CHIPS RIGHT END  ******************/}

                </div>
                <div className="winnerTable">
                  <table border="0" cellSpacing="0" cellPadding="0" className="tableLandscape">
                    <thead>
                      <tr>
                        <th> {this.props.language.Card} </th>
                        <th> {this.props.language.Bet} </th>
                        <th> {this.props.language.Winner}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {this.winnerObj.map((data, i) => (
                            <span key={i}>

                              {data}

                              <br></br>
                            </span>
                          ))}
                        </td>

                        <td>
                          {this.betObj.map((data, i) => (
                            <span key={i}>

                              {data}

                              <br></br>
                            </span>
                          ))}
                        </td>
                        <td>
                          {player.map((data, i) => (
                            <span key={i}>
                              {data}
                              <br></br>
                            </span>
                          ))}
                        </td>
                      </tr>
                    </tbody>
                  </table>


                  <table border="0" cellSpacing="0" cellPadding="0" className="tableportairt">

                    <tbody>

                      <tr>
                        <td>{this.props.language.Winner}</td>
                        {player.map((data, i) => (
                          <td>
                            <span key={i}>
                              {data === "Dealer" ? "D" : "P"}

                              <br></br>
                            </span>
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td>{this.props.language.Card}</td>
                        {this.winnerObj.map((data, i) => (
                          <td>
                            <span key={i} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>


                              <span>{String(data)[0]}</span>
                              <span style={{ marginTop: "10px", marginLeft: "10px" }}>{String(data)[1] === "H" ? (
                                <svg width="30" height="30" viewBox="0 0 24 24" fill="red" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 21s-6.6-4.35-9.24-8.58C-.31 8.52 3.4 3 7.5 5.5 10.26 7.17 12 10 12 10s1.74-2.83 4.5-4.5C20.6 3 24.31 8.52 21.24 12.42 18.6 16.65 12 21 12 21z" />
                                </svg>
                              ) : String(data)[1] === "S" ? (<svg width="30" height="30" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2S4 9 4 13c0 2.76 2.24 5 5 5a4.99 4.99 0 003-1v2H9v3h6v-3h-3v-2a4.99 4.99 0 003 1c2.76 0 5-2.24 5-5 0-4-8-11-8-11z" />
                              </svg>)
                                : String(data)[1] === "D" ?
                                  (<svg width="30" height="30" viewBox="0 0 24 24" fill="red" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2l7 10-7 10-7-10 7-10z" />
                                  </svg>
                                  )
                                  :

                                  (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="30" height="30" fill="black">
                                    <path d="M32 2C24.8 2 19 7.8 19 15c0 3.2 1.3 6.1 3.4 8.2-5.3 1.6-9.1 6.5-9.1 12.3 0 7.2 5.8 13 13 13 2.8 0 5.3-0.9 7.4-2.4V54H25v8h14v-8h-8.7v-7.9c2.1 1.5 4.6 2.4 7.4 2.4 7.2 0 13-5.8 13-13 0-5.8-3.8-10.7-9.1-12.3C43.7 21.1 45 18.2 45 15c0-7.2-5.8-13-13-13z" />
                                  </svg>
                                  )
                              }</span>

                              <br></br>
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>


                </div>
                <div className="fc_buttonList">
                  <BottomPanel
                    disableClearBtn={this.props.disableClearBtn}
                    disableDealBtn={this.props.disableDealBtn}
                    disable={this.props.disable}
                    btnActive={this.props.btnActive}
                    betBtnTxt={this.props.betBtnTxt}
                    betCard={this.props.betCard}
                    doubleAmount={this.props.doubleAmount}
                    message={this.props.message}
                    dealBtn={this.props.dealBtn}
                    betButtonValue={this.props.betButtonValue}
                    cleareBtn={this.props.cleareBtn}
                    childRef={ref => (this.BottomPanel = ref)}

                  ></BottomPanel>
                  <div className="fd d-flex">
                    <label className="playerCheck">
                      <input type="checkbox" id="playerDealer" value="true" />
                      {this.props.language.PlayerFirst}
                    </label>
                  </div>
                </div>
              </div>
              {/************************** DEALER & PLAYER TABLE END  ******************/}

            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatesToProps = (state) => {
  return {
    language: state.languageObjs.languageObj

  }
}
export default connect(mapStatesToProps)(ChipsDealerPlayer)